export default __webpack_public_path__ + "assets/images/peergame-logo-dark-3a6ecce79603d2bebc3dd1fc62f296b3.svg";